import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import MachineryContent from './MachineryContent';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';

const form = {
  keyword: '',
};

function ListOfMachineryContainer({
  match,
  history,
  getList,
  dataList,
  isLoading,
  dataListPager,
  removeData,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Machinery',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Machinery',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this machine?',
      () => {
        removeData(data.id, () => {
          history.push(`/rpt/machinery/machinery-settings/list-of-machinery`);
          getList();
        });
      },
      false,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getList({ q: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:machineId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="List of Machinery"
            getData={getList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:machineId?`}
            listName="machines"
            label="List of Machinery"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'attributes.brand_model')}
                </h4>
              </div>
            )}
            noRightCard
            isLoading={isLoading}
            selected={params.machineId}
            data={dataList}
            dataPager={dataListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:machineId?`}
                    render={() => (
                      <MachineryContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:machineId?`}
                  render={() =>
                    !params.machineId && dataList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(dataList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

ListOfMachineryContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  removeData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_LIST}.list`) || [],
  dataListPager: _.get(api, `${c.GET_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ListOfMachineryContainer);
